var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dapp-progress"},[_vm._l((_vm.steps),function(i){return _c('div',{key:i,staticClass:"item",class:{ completed: i <= _vm.completedSteps }})}),(_vm.endIcon)?_c('img',{staticClass:"icon end",attrs:{"src":_vm.getImageUrl(_vm.endIcon),"alt":"50 friends referred"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }